import { gql } from '@apollo/client'
import { BodyText, Heading } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'

import { InconsistentPlanLockContent_OfferLockDataFragment } from './__generated__/content.graphql'
import styles from './inconsistent-plan-lock.module.scss'

interface ContentProps {
  offerLockData: InconsistentPlanLockContent_OfferLockDataFragment
}

export const Content = ({ offerLockData }: ContentProps) => {
  if (!offerLockData?.body?.cards?.length) {
    return null
  }

  const {
    header,
    body: {
      cards: [card],
    },
  } = offerLockData

  const image = card.image
  const [description] = card.descriptions

  return (
    <>
      {image.src && <Image alt={image.alt} src={image.src} width={160} height={160} />}

      <Heading size="md" className={styles.title} asChild>
        <h3>{header.title}</h3>
      </Heading>

      {description && (
        <BodyText size="lg" className={styles.descriptions}>
          <span>{description}</span>
        </BodyText>
      )}
    </>
  )
}

Content.fragments = {
  offerLockData: gql`
    fragment InconsistentPlanLockContent_offerLockData on OfferLockData {
      header {
        title
      }
      body {
        cards {
          descriptions
          image {
            alt
            src
          }
        }
      }
    }
  `,
}
